// Shared by the SEO-page insight blocks: one fetch per page load, formatting
// for English-only pages (the /page/* views are not translated, see CLAUDE.md).
import { playtimeAPI } from '../services/api';

let pending = null;

// Both blocks can sit on one page; they share the request. A failure clears it
// so a later mount retries.
export function loadSiteInsights () {
    if (!pending) {
        pending = playtimeAPI.getSiteInsights()
            .then(res => res?.data?.insights || null)
            .catch(() => {
                pending = null;
                return null;
            });
    }

    return pending;
}

export function formatMinutes (minutes) {
    const total = Math.round(Number(minutes) || 0);
    const h = Math.floor(total / 60);
    const m = total % 60;

    if (!h) return `${m}m`;

    return m ? `${h}h ${m}m` : `${h}h`;
}

export function formatHours (minutes) {
    return `${Math.round((Number(minutes) || 0) / 60).toLocaleString('en-US')}h`;
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// "Sep 12 – Oct 9" from two YYYY-MM-DD keys (UTC, no Date parsing quirks).
export function formatRange (from, to) {
    const fmt = key => {
        const [, mo, d] = String(key).split('-').map(Number);

        return `${MONTHS[mo - 1]} ${d}`;
    };

    return `${fmt(from)} – ${fmt(to)}`;
}

export function gameHeaderUrl (game) {
    return game.headerImage
        || `https://shared.fastly.steamstatic.com/store_item_assets/steam/apps/${game.appId}/header.jpg`;
}
